import throttle from 'lodash/throttle';
import { useCallback } from 'react';

export const useLazyLoading = ({
  // @ts-ignore
  onIntersection,
  delay = 1000,
  marginFromBottom = 10,
}) => {
  const onScroll = useCallback(
    throttle(() => {
      const containerScrollTop = document.documentElement.scrollTop;
      const containerHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      if (scrollHeight - containerScrollTop - containerHeight - marginFromBottom <= 0) {
        onIntersection();
      }
    }, delay),
    [onIntersection, marginFromBottom, delay]
  );

  return [onScroll];
};
